<template>
  <v-container>
    <v-layout>
        <v-flex lg8 mx-auto>
            <v-card class="green lighten-4 pa-6 mx-auto justify-center mt-12 elevation-13">
                <v-card-title class="display-2 text--primary justify-center font-weight-black"><p class="teal--text">문의 정보</p></v-card-title>
                <v-card class="pa-0 elevation-6">
                    <v-simple-table>
                    <template>
                      <tbody>
                        <tr>
                          <td class="font-weight-bold">주소</td>
                          <td>서울특별시 중구 다산로 32, 남산타운 제 5상가 328호</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">전화번호</td>
                          <td>(02) 3141-2345</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">팩스</td>
                          <td>(02) 725-2346</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">이메일</td>
                          <td>yhm@limokorea.co.kr</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-card>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ContactMain',
  data: () => ({
  }),
};
</script>
<style scoped>
</style>
